import React, { useState } from "react";

import "./project_toolbar.less";
import DuplicateIcon from "@src/assets/icons/duplicate.svg";
import PencilIcon from "@src/assets/icons/pencil.svg";
import TrashIcon from "@src/assets/icons/trash.svg";
import { DeleteProjectConfirmationModal } from "@src/components/modals/delete_project_confirmation_modal";
import { EditProjectModal } from "@src/features/projects/components/edit_project_modal";
import { Project } from "@src/types";
import { Button, Tooltip } from "antd";
import { useNavigate } from "react-router-dom";

interface ProjectToolbarProps {
  project: Project;
  isDisabled: boolean;
}

const ProjectToolbar: React.FC<ProjectToolbarProps> = ({
  project,
  isDisabled,
}) => {
  const navigate = useNavigate();
  const [showEditProjectModal, setShowEditProjectModal] =
    useState<boolean>(false);
  const [showDeleteProjectModal, setShowDeleteProjectModal] =
    useState<boolean>(false);

  return (
    <div className="project-toolbar">
      <Tooltip placement="top" title={"Edit Project"}>
        <Button
          data-testid="edit-project-button"
          size="large"
          color="primary"
          variant="filled"
          disabled={isDisabled}
          icon={<PencilIcon data-testid="pencil-icon" />}
          onClick={() => setShowEditProjectModal(!showEditProjectModal)}
        />
      </Tooltip>

      <Tooltip placement="top" title={"Duplicate Project"}>
        <Button
          data-testid="duplicate-project-button"
          size="large"
          color="primary"
          variant="filled"
          disabled={isDisabled}
          icon={<DuplicateIcon data-testid="duplicate-icon" />}
          onClick={() => navigate(`/projects/create/${project?.id}`)}
        />
      </Tooltip>

      <Tooltip placement="top" title={"Delete Project"}>
        <Button
          data-testid="delete-project-button"
          size="large"
          color="primary"
          variant="filled"
          className="delete-button"
          disabled={isDisabled}
          icon={<TrashIcon data-testid="trash-icon" />}
          onClick={() => setShowDeleteProjectModal(!showDeleteProjectModal)}
        />
      </Tooltip>

      {showEditProjectModal && (
        <EditProjectModal
          modalVisible={showEditProjectModal}
          project={project}
          setModalVisible={setShowEditProjectModal}
        />
      )}

      {showDeleteProjectModal && (
        <DeleteProjectConfirmationModal
          setModalVisible={setShowDeleteProjectModal}
          modalVisible={showDeleteProjectModal}
          projectId={project.id}
          onDeleteCallback={() => navigate("/projects")}
        />
      )}
    </div>
  );
};

export default ProjectToolbar;
